import { css } from 'styled-components';

export default css`
  a,
  a:visited,
  a:not([href]):not([tabindex]) {
    color: ${props => props.theme.colors.primary.primary};
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
  }

  a:hover,
  a:active,
  a:not([href]):not([tabindex]):hover {
    color: #13618e;
    text-decoration: underline;
  }
`;
